import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogOverlay, Box, HStack } from "@chakra-ui/react";
import { useRef, useState } from "react";
import { setFocusLocked } from "../../Store/GlobalReducer";
import { useAppDispatch } from "../../Store/hooks";
import { colors } from "../../Theme";

const LightSwitcher = (props: { setColor: (color: number) => void }) => {
  const [isOpen, setIsOpen] = useState(false);
  const cancelRef = useRef<HTMLButtonElement>(null);

  const [color, setColor] = useState(0xfdfbd3);

  const dispatch = useAppDispatch();

  const onClose = () => {
    setIsOpen(false);
    dispatch(setFocusLocked(false));
  };

  const onOpen = () => {
    setIsOpen(true);
    dispatch(setFocusLocked(true));
  };
  const sunColors = [0xffffff, 0xffe8b2, 0xf9f37a, 0xfdfbd3, 0xffa95c];

  const hexToRGB = (color: number): string => {
    return `rgb(${Math.floor((color / 256 / 256) % 256)}, ${Math.floor(
      (color / 256) % 256
    )}, ${Math.floor(color % 256)})`;
  };
  return (
    <>
      <Box
        w={"2rem"}
        h={"2rem"}
        cursor="pointer"
        onClick={onOpen}
        bgColor={hexToRGB(color)}
      />

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent bg={colors.badgeLight}>
            <AlertDialogBody>
              <HStack wrap="wrap" align="center" justify="center">
                {sunColors.map((color) => (
                  <Box
                    w={30}
                    h={30}
                    cursor="pointer"
                    bgColor={hexToRGB(color)}
                    onClick={() => {
                      onClose();
                      setColor(color);
                      props.setColor(color);
                    }}
                  />
                ))}
              </HStack>
            </AlertDialogBody>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default LightSwitcher;
